// extracted by mini-css-extract-plugin
module.exports = {"counterIcon":"counterIcon_RhVO6","counterIconT":"counterIconT_dJ0-d"};